import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';

const CollapsibleCard = ({
  header,
  children,
  defaultOpen = false,
  className = '',
  headerClassName = '',
  headerStyle = {},
  bodyClassName = '',
  style = {},
  cardBodyStyle = {},
  toggleIcon = null,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card
      className={`mb-2 border-0 ${className}`}
      style={{ borderRadius: '14px', ...style }}
    >
      <CardHeader
        onClick={() => setOpen((o) => !o)}
        className={`d-flex align-items-center justify-content-between ${headerClassName}`}
        style={{
          cursor: 'pointer',
          borderRadius: '14px',
          minHeight: 48,
          transition: 'background 0.2s',
          ...headerStyle,
        }}
      >
        <div className="flex-grow-1">{header}</div>
        <span
          style={{
            transition: 'transform 0.25s cubic-bezier(0.4,0,0.2,1)',
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
            marginLeft: 12,
            color: '#854fff',
            fontSize: 20,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {toggleIcon || (
            <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 5l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </span>
      </CardHeader>
      <Collapse isOpen={open}>
        <CardBody
          className={`${bodyClassName}`}
          style={{
            background: '#fff',
            borderRadius: '0 0 14px 14px',
            transition: 'background 0.2s',
            ...cardBodyStyle,
          }}
        >
          {children}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default CollapsibleCard;
